<template>
    <span>
        <span v-show="enabled">
            <span  class="layuiradio">
                 <slot></slot>
            </span>
        </span>
        <span v-show="!enabled">
            <span class="layuiradio-disabled">
            </span>
        </span>
    </span>
</template>

<script>

export default {
    name: 'LayuiRadio',
    props: {
        enabled: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
        _model: {
            default: null,
            required: false
        },
        textField: {
            default: "text",
            type: String
        },
        valueField: {
            default: "value",
            type: String
        },
         // 配置了 tableName 那么slot插槽就不起作用
        tableName: {
            type: String,
            default: ''
        },
        queryCondition: {
            type: Object,
            default: () => {
                return {};
            }
        },
        showNullOption : {
            type: Boolean,
            default: false
        },
        selectFields: {
            type: String,
            default: '',        
        },
        sort: {
            type: Array,
            default: () => {
                return []
            }
        },
        initValue: {
            required: false,
            type: String
        },
        initData: {
            type: Array,
            default: () => {
                return []
            }
        },
        selectFirst : {
            type: Boolean,
            default: false
        },
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data () {
        return {
            id : null,
            el : null,
            isloaded: false,
            selectData: {}, //当前选中的值
            data: []
        }
    },
    methods: {
        getData() {
            return this.data;
        },
        getSelectData() {
            return this.selectData;
        },
        setData(data) {
            this.data = data;
        },
        getDataByValue(value) {
           return this.data.find((obj)=>{
                if(obj[this.valueField] == value) {
                    return obj;
                }
            });
        },
        // 根据给定的记录，选中select
        // 该方法不应该，也不会修改v-model绑定的值
        select(value) {
            // null 作为空值来处理，防止报错
            if (value == null) {
                value = '';
            }
            this.selectData = this.getDataByValue(value);
            if(!this.ui_update) {
                this.addRadioClass(this.radio, value);
                this.addRadioClass(this.disabledRadio, value);
            }
            this.ui_update = false;
        },
        addRadioClass(radioEl, value){
            radioEl.find('i').removeClass('layui-anim-scaleSpring').text('');
            radioEl.find('.layui-unselect').removeClass('layui-form-radioed');
            if (value) {
                var next = radioEl.find('input[value = ' + value + ']').next();
                next.addClass('layui-form-radioed');
                next.find('i').addClass('layui-anim-scaleSpring').text('');
            }
        },
        // 根据最新的data,刷新select
        load() {
            this.radio.children().remove();
            this.disabledRadio.children().remove();
            this.data.forEach((item)=> {
                var arr = [];
                arr.push('<input type="radio"  name="' + this.id + '" value="' + item[this.valueField] + '" title="' + item[this.textField]);
                arr.push('" lay-filter="' + this.id + '" ');
                arr.push('"  disabled="disabled"  lay-filter="' + this.disabledId + '" ');
                arr.push('/>');
                this.radio.append(arr[0] + arr[1] + arr[3]);
                this.disabledRadio.append(arr[0] + arr[2] + arr[3])
            });
            this.layui.form.render('radio', this.id);
            this.layui.form.render('radio', this.disabledId);
            this.layui.form.on('radio(' + this.id + ')', (data) => {
                this.ui_update = true;
                // 通知v-model修改所绑定的值, 该事件会修改this._model的值,以及v-model所绑定的值
                if(data.value == this._model) {
                    // 重复点击，认为是取消操作
                    this.$emit('_modelEvent', '');
                    this.$emit('modelChange',{});
                    this.$emit('selectChange',{});
                    this.addRadioClass(this.radio, null);
                    this.addRadioClass(this.disabledRadio, null);
                } else {
                    this.$emit('_modelEvent', data.value);
                    this.selectData = this.getDataByValue(data.value);
                    this.$emit('modelChange',this.selectData);
                    this.$emit('selectChange',this.selectData);
                    this.addRadioClass(this.disabledRadio, data.value);
                }
                
            });
        },
        afterLoad() {
            // 这时组件加载完了，但是可能外部已经修改了model的值，
           // 如果已经修改了，那么就不用执行initValue的逻辑了，因为这个时候initValue的值已经不算是最新的值了
            if(this._model) {
                this.select(this._model);
                this.$emit('modelChange',this.selectData);
            } else {
                if(this.initValue) {
                    // 修改v-model绑定的值
                    this.$nextTick(()=> {
                        // 注意$emit这里会触发下面watch监听的_model方法
                        // 是为了给v-model绑定的属性赋值
                        this.$emit('_modelEvent',this.initValue);
                        this.selectData = this.getDataByValue(this.initValue);
                        this.$emit('modelChange',this.selectData);
                    });
                }
            }
            this.handleEnabled();
        },
        handleEnabled() {
            
        }
    },
    mounted(){
        var element = this.el = $(this.$el);
        var id = this.id = this.uuid();
        this.disabledId = this.id + "_disabled";
        this.radio = element.find(".layuiradio");
        this.disabledRadio = element.find(".layuiradio-disabled");
        this.radio.attr('lay-filter', id);
        this.disabledRadio.attr('lay-filter', this.disabledId);
        if(this.initData && this.initData.length > 0) {
            this.data = this.initData;
            this.load();
            this.isloaded = true;  
            this.afterLoad();
        } else if(this.tableName) {
            var p2 = this.queryCondition;
            this.api.queryList(
                    this.tableName, 
                    {p2: p2,  p9: this.selectFields, p10: this.sort},
                    this.requestUniqueId
                ).then(response => {
                var results = response.result;
                this.data = results;
                this.load();       
                this.isloaded = true;       
                this.afterLoad();
            });
        } else  {
            var children = this.radio.children();
            if(children.length > 0){
                for(var i = 0 ; i < children.length; i++) {
                    var child = $(children[i]);
                    var value = child.attr('value');
                    var text = child.attr('title');
                    var obj = {};
                    obj[this.valueField] = value;
                    obj[this.textField] = text;
                    this.data.push(obj);
                }
                 this.load();  
                 this.isloaded = true;  
                 this.afterLoad();
             }
        }
        
    },
    watch:{
        _model(value){
            if(this.isloaded ) {
                this.select(value);
            }
        },
        enabled() {
            if(this.isloaded) {
                this.handleEnabled();
            }
           
        }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/common/LayuiRadio.vue